import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-radio-on",
  "use": "icon-radio-on-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-radio-on\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <rect stroke=\"currentColor\" fill=\"currentColor\" x=\".5\" y=\".5\" width=\"23\" height=\"23\" rx=\"11.5\" />\n        <rect fill=\"#FFF\" x=\"6\" y=\"6\" width=\"12\" height=\"12\" rx=\"6\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol